
import "./style.css";

function ProgressBar(props) {
    let { min = 0, max = 24, value = 1, showLabel = true, barColor, height, gradient=null } = props;
    let perc = ((value - min) / (max - min)) * 100;
    perc = (isNaN(perc) || perc < 0) ? 0 : perc;

    let progressBarStyle = {
        height: height || "5px"
    }

    if (barColor) {
        progressBarStyle["backgroundColor"] = barColor;
    }

    const progressBarInlineCSS = { width: (perc > 100 ? 100 : perc) + "%" };
    if (gradient) {
        progressBarInlineCSS.backgroundImage = `linear-gradient(to right, ${gradient?.[0]}, ${gradient?.[1]})`
    }

    return (
        <div id="custom-progress-bar-wrapper">
            <div id="custom-progress-bar">

                <div id="progress-bar" style={progressBarStyle}>
                    {
                        showLabel &&
                        <>
                            <h6 className="min">{min}</h6>
                            {
                                perc > 100 ? "" : <h6 className="max">{max}</h6>
                            }
                        </>

                    }

                    <div id="pb-complete" style={progressBarInlineCSS}>
                        {
                            showLabel &&
                            <span style={{color:`${gradient?.[0]}`}}>{value == 0 ? "" : value}</span>
                        }

                    </div>


                </div>

            </div>
        </div>
    );
}

export default ProgressBar;